import {FormArray, FormControl, FormGroup} from "@angular/forms";

export const recursiveForm = (f: FormGroup | FormArray) => {
  for (const i in f.controls) {
    if (typeof f.controls[i].value === 'string') {
      if (f.controls[i].value.trim().length === 0) {
        f.controls[i].value = null;
      }
    }
    if (f.controls[i] instanceof FormControl) {
      f.controls[i].markAsDirty();
      f.controls[i].updateValueAndValidity();
    } else {
      recursiveForm(f.controls[i] as any);
    }
  }
};
